var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlvenaria(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.946,
    height: 46.633,
    viewBox: "0 0 57.946 46.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_983",
    "data-name": "Grupo 983",
    transform: "translate(-552.699 -617.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_975",
    "data-name": "Grupo 975",
    transform: "translate(560.107 617.648)",
    opacity: 0.346
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_457",
    "data-name": "Grupo 457",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M2.262,25.578,14.62,32.713a4.523,4.523,0,0,1,1.656,6.179l-4.47,7.741H36.119a4.524,4.524,0,0,0,3.918-2.262l9.895-17.137a4.524,4.524,0,0,0-1.656-6.179L35.918,13.92a4.524,4.524,0,0,1-1.657-6.18L38.73,0H14.418A4.523,4.523,0,0,0,10.5,2.262L.606,19.4a4.524,4.524,0,0,0,1.656,6.179",
    transform: "translate(0)",
    fill: "#d9d9d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_974",
    "data-name": "Grupo 974",
    transform: "translate(-336.248 129.393)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_676",
    "data-name": "Ret\\xE2ngulo 676",
    width: 6.171,
    height: 6.171,
    transform: "translate(889.697 503.807)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_677",
    "data-name": "Ret\\xE2ngulo 677",
    width: 6.171,
    height: 6.171,
    transform: "translate(889.697 516.998)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_678",
    "data-name": "Ret\\xE2ngulo 678",
    width: 6.171,
    height: 6.171,
    transform: "translate(922.844 516.998)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_679",
    "data-name": "Ret\\xE2ngulo 679",
    width: 13.106,
    height: 6.171,
    transform: "translate(896.07 516.998)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_680",
    "data-name": "Ret\\xE2ngulo 680",
    width: 13.106,
    height: 6.171,
    transform: "translate(909.356 516.998)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_681",
    "data-name": "Ret\\xE2ngulo 681",
    width: 13.106,
    height: 6.171,
    transform: "translate(889.697 510.403)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_682",
    "data-name": "Ret\\xE2ngulo 682",
    width: 13.106,
    height: 6.171,
    transform: "translate(902.803 523.593)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_683",
    "data-name": "Ret\\xE2ngulo 683",
    width: 13.106,
    height: 6.171,
    transform: "translate(915.909 523.593)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_684",
    "data-name": "Ret\\xE2ngulo 684",
    width: 13.106,
    height: 6.171,
    transform: "translate(889.697 523.593)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_313",
    "data-name": "Linha 313",
    x2: 18.887,
    transform: "translate(909.777 509.543)",
    fill: "#fff",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_685",
    "data-name": "Ret\\xE2ngulo 685",
    width: 13.106,
    height: 6.171,
    transform: "translate(902.803 510.403)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_686",
    "data-name": "Ret\\xE2ngulo 686",
    width: 13.106,
    height: 6.171,
    transform: "translate(915.909 510.403)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_687",
    "data-name": "Ret\\xE2ngulo 687",
    width: 13.106,
    height: 6.171,
    transform: "translate(896.07 503.807)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlvenaria);
export default __webpack_public_path__ + "static/media/alvenaria.abead04f7ac88909502976342e6291de.svg";
export { ForwardRef as ReactComponent };